import React, { useState } from "react"
import "./main-banner.scss"
import Img from "gatsby-image"
import ModalShare from "../../../shared/components/molecules/modal-share/modal-share"
import ReturnButton from "../../atoms/return-button/return-button"

const MainBanner = props => {
    const { webinarInfo, isMobile, isCompleted = false, isSecondStyle = false } = props

    const [isModalActive, setModalActive] = useState()

    const inscriptionGTM = () => {
        try {
            window.dataLayer.push({
                'event': 'ga_event_consultorio',
                'category': 'Eventos :: Próximo evento',
                'action': 'Click :: Inscribirse',
                'label': webinarInfo.bannerPrincipal[0]?.nombre,
                'value': 'Próximo evento'
            });
        } catch (e) {
            console.log('dataLayer Error', e);
        }

        let el = document.getElementById("inscripcion");
        window.scrollTo({
            top: el?.offsetTop - (isMobile ? 90 : 200),
            behavior: "smooth",
        });
    }

    const inscriptionCompletedGTM = () => {
        window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push({
        //         'event': 'ga_event_consultorio',
        //         'category': 'Eventos :: Próximo evento',
        //         'action': 'Click :: Ver charlas',
        //         'label': webinarInfo.bannerPrincipal[0]?.nombre,
        //         'value': 'Próximo evento'
        //     });

        let el = document.getElementById("agenda");
        window.scrollTo({
            top: el?.offsetTop - (isMobile ? 90 : 200),
            behavior: "smooth",
        });
    }


    const titleStatus = () => {
        let title;
        if (webinarInfo.estadoWebinar.toLowerCase() === "después del evento") {
            title = "Descargar certificado"
        } else if (webinarInfo.estadoWebinar.toLowerCase() === "en el evento") {
            title = "Ingresa a la conferencia"
        } else {
            title = "Inscríbete aquí"
        }
        return title;
    }

    return (
        <div className={isSecondStyle ? "m-banner--secondary" : "m-banner"}>
            <div className="m-banner__content">
                <div className="m-banner__content__return">
                    <ReturnButton href="/academia-tena/" />
                </div>
                <div className="m-banner__content__banner" onClick={() => {
                    isCompleted ?
                        inscriptionCompletedGTM()
                        :
                        inscriptionGTM()
                }
                }>
                    <Img
                        className="f-img-banner"
                        fluid={
                            isMobile
                                ? webinarInfo.bannerPrincipal[0].bannerMobile
                                    .fluid
                                : webinarInfo.bannerPrincipal[0].bannerDesktop
                                    .fluid
                        }
                        alt={webinarInfo.bannerPrincipal[0].bannerDesktop.description}
                    />
                    <div className="m-banner__content__banner__info">
                        <div className="m-banner__content__banner__info__content">
                            <h4 className="m-banner__content__banner__info__content__main"><span>{webinarInfo.bannerPrincipal[0].nombre}</span></h4>
                        </div>
                        <p className="m-banner__content__banner__info__date">{webinarInfo.bannerPrincipal[0].descripcionImagen}</p>
                        <p className="m-banner__content__banner__info__desc">{webinarInfo.bannerPrincipal[0].descripcionImagen2}</p>
                        {webinarInfo.bannerPrincipal[0].tieneBoton &&
                            (
                                isCompleted ?
                                    <div className="m-banner__content__banner__info__content">
                                        <div className="m-banner__content__banner__info__content__btn m-banner__content__banner__info__content__btn--charla">VER CHARLAS</div>
                                        <button
                                            className="m-banner__content__banner__info__content__btn-share"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setModalActive(true)
                                            }}
                                        >
                                            <span>Compartir</span>
                                            <i className="icon-share"></i>
                                        </button>
                                    </div>
                                    :
                                    <div className="m-banner__content__banner__info__content">
                                        <div className="m-banner__content__banner__info__content__btn">{titleStatus()}</div>
                                        <button
                                            className="m-banner__content__banner__info__content__btn-share"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setModalActive(true)
                                            }}
                                        >
                                            <span>Compartir</span>
                                            <i className="icon-share"></i>
                                        </button>
                                    </div>
                            )
                        }
                    </div>
                </div>
                <div></div>
            </div>
            {isModalActive && (
                <ModalShare
                    hideAction={() => {
                        setModalActive(false)
                    }}
                />
            )}
        </div>
    )
}

export default MainBanner
